import { useEffect, useState } from "react";
import { listContacts } from "../../lib/api";

function formatDate(iso) {
  try {
    return new Date(iso).toLocaleString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

function ContactRow({ c }) {
  return (
    <div
      data-testid={`contact-row-${c.id}`}
      className="grid grid-cols-1 md:grid-cols-12 gap-3 md:gap-6 py-6"
    >
      <div className="md:col-span-3">
        <div className="font-serif text-lg text-ink">{c.name}</div>
        <a href={`mailto:${c.email}`} className="text-sm text-river hover:underline break-all">
          {c.email}
        </a>
        <div className="mt-1 text-xs text-ink-muted font-accent uppercase tracking-wide">
          {c.enquiry_type}
        </div>
      </div>
      <div className="md:col-span-7 whitespace-pre-wrap text-ink-muted leading-relaxed">
        {c.message}
      </div>
      <div className="md:col-span-2 text-xs text-ink-muted font-accent text-right">
        {formatDate(c.created_at)}
      </div>
    </div>
  );
}

export default function AdminMessagesPage() {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    listContacts()
      .then(setContacts)
      .catch(() => setContacts([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p className="text-ink-muted font-accent">Loading messages…</p>;

  return (
    <div data-testid="admin-messages-page">
      <div className="text-sm font-accent text-ink-muted mb-8">
        {contacts.length} message{contacts.length === 1 ? "" : "s"}
      </div>
      {contacts.length === 0 ? (
        <div className="border border-rule bg-linen-alt p-10 text-center text-ink-muted">
          No contact submissions yet.
        </div>
      ) : (
        <div className="divide-y divide-rule border-y border-rule">
          {contacts.map((c) => (
            <ContactRow key={c.id} c={c} />
          ))}
        </div>
      )}
    </div>
  );
}
